import * as queries from "./query";
import RootService from "@services";

export default new RootService({ queries });

import SearchService from "@services/Search";
import ServiceService from "@services/Service";
import QuestionService from "@services/Question";

export const searchService = new SearchService({ queries });
export const serviceService = new ServiceService({ queries });
export const questionService = new QuestionService({ queries });
